import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Typography, Grid, TextField, Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { genfunction } from 'helpers';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import { Autocomplete } from '@material-ui/lab';
import { actionGetOrganizationSection, actionResetOrganizationSection } from 'actions/actionOrganizationSection';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';

const { OrganizationNameHeader, OrganizationInstructionText, OrganizationChangePopupMsg, PurchaseOrganizationBookingNotAllowedForMembership } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    box100per: {
        width: "100%"
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    OrganizationInfoCls: {
        padding: '16px',
        textAlign: 'justify'
    },

}));

const OrganizationSection = (props) => {
    const classes = useStyles();

    const [errorMsg, seterrorMsg] = useState("");
    const [colorState, setColorState] = React.useState('');
    const dispatch = useDispatch();

    const reducerOrganizationSection = useSelector(state => state.reducerOrganizationSection);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0] : null;
    const cartEvents = useSelector(state => state.reducerShopCart.events);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const countryandstates = useSelector(state => state.reducerCountryAndState.countryandstate);
    let defaultCountry = countryandstates && countryandstates.length > 0 ? countryandstates[0].Country : "";

    useEffect(() => {

        if (reducerOrganizationSection.organizationlisterror !== undefined && reducerOrganizationSection.organizationlisterror.length > 0) {
            seterrorMsg(reducerOrganizationSection.organizationlisterror);
        }
    }, [reducerOrganizationSection.organizationlisterror]);

    useEffect(() => {
        if (reducerOrganizationSection.loading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [reducerOrganizationSection.loading]);


    useEffect(() => {


        if (bkngType.RestrictCompanyListByCostRate) {
            let costRateList = Object.keys(bkngType.AllowedCostRateIDs).map(function (k) { return bkngType.AllowedCostRateIDs[k].CostRateID }).join(",");
            actionGetOrganizationSection(dispatch, costRateList.toString());

        }
        else
            actionResetOrganizationSection(dispatch);

        if (genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID))
            handleChange("Organization");


    }, [])

    const errorcancelhandle = () => {
        if (reducerOrganizationSection.organizationlisterror.length > 0)
            actionResetOrganizationSection(dispatch)

        seterrorMsg("");
    }

    const handleChange = (value) => {

        if (value === "Organization")
            props.handleChange(true)

        else {
            props.handleChange(false);
            props.onChange(null);
        }

    }

    const validateChangeOrganization = (event, value) => {

        if (membershipPackages && membershipPackages.length > 0) {
            setColorState('info');
            seterrorMsg(PurchaseOrganizationBookingNotAllowedForMembership);
        }
        else if (genfunction.IsOrganization(cartEvents)) {

            let indexOrg = cartEvents.findIndex(x => x.OrganizationID !== "" && x.TourEventID !== props.tourEventId);

            if (indexOrg >= 0 && value && cartEvents[indexOrg].OrganizationID !== value.CustomerID)
                seterrorMsg(OrganizationChangePopupMsg);
            else
                props.onChange(value);
        }

        else
            props.onChange(value);
    }
    
    let organizationTxt = genfunction.GetValueFromCountryAndState(countryandstates, defaultCountry, "OrganizationText");

    return (
        <div >
            <ErrorHandling msg={errorMsg} color={colorState} open={errorMsg != ""} handleclose={errorcancelhandle} />

            <Card style={{ borderRadius: "0" }} className={classes.box100per}>
                <CardHeader className={classes.tourheaderbox}
                    title={OrganizationNameHeader}
                    titleTypographyProps={{ color: "inherit" }}
                />

                <CardContent >
                    {bkngType.AllowedCustomerTypes === "All" && bkngType.ShowTourProductsBasedOnGroupSize ?

                        <Grid container>
                            <Grid item xs={1} ms={1} lg={1}></Grid>
                            <Grid item xs={10} ms={10} lg={10}>
                                <RadioGroup className={classes.box100per} aria-label="purchaser" name="purchaser-group"
                                    defaultValue={genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID) ? "Organization" : "Individual"}
                                    onChange={({ target: { value } }) => handleChange(value)}
                                >

                                    <FormControlLabel value="Individual" control={<Radio />} label="Purchase as an Individual" />
                                    <FormControlLabel value="Organization" control={<Radio />} label={"Purchase as an " + organizationTxt} />
                                </RadioGroup>
                            </Grid>
                            <Grid item xs={1} ms={1} lg={1}></Grid>

                        </Grid>
                        : null
                    }
                    {props.showOrganization || bkngType.RequireCompanyName || (!bkngType.ShowTourProductsBasedOnGroupSize && props.isContinueToGroupDrawer) ?

                        <Grid style={{ padding: "10px", width: "100%" }} container alignItems="center" item xs={12} ms={12} lg={12} >

                            <Grid item xs={1} ms={1} lg={1}></Grid>
                            <Grid item xs={10} ms={10} lg={10}>
                                {reducerOrganizationSection.organizationlist && reducerOrganizationSection.organizationlist.length > 0 ?
                                    <Autocomplete
                                        id="organization"
                                        name="organization"
                                        options={reducerOrganizationSection.organizationlist}
                                        fullWidth={true}
                                        onChange={validateChangeOrganization}
                                        autoHighlight
                                        getOptionLabel={(option) => {
                                            if (option.hasOwnProperty('CustomerName')) {
                                                return option.CustomerName;
                                            }

                                            return option.toString();
                                        }}
                                        value={genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID) ?
                                            reducerOrganizationSection.organizationlist.filter(x => x.CustomerID === props.organizationID)[0] : ""}

                                        style={{ width: "100%" }}
                                        renderInput={(params) => <TextField {...params} variant='outlined' label={"Select an " + organizationTxt} />}

                                    ></Autocomplete>

                                    : ""}
                            </Grid>
                            <Grid item xs={1} ms={1} lg={1}></Grid>

                            <Grid item xs={1} ms={1} lg={1}></Grid>
                            <Grid item xs={10} ms={10} lg={10}>
                                <Typography variant="body2" color="textSecondary" className={classes.OrganizationInfoCls}>
                                    {ReactHtmlParser(genfunction.replaceEscapeCharacters(OrganizationInstructionText))}
                                </Typography>
                            </Grid>
                            <Grid item xs={1} ms={1} lg={1}></Grid>
                        </Grid>
                        : null}

                </CardContent>
            </Card>
        </div >
    );
}

export default OrganizationSection;


